var map = {
	"./1 FRONT PAGE/CARRUSEL BODAS/1.jpg": 6132,
	"./1 FRONT PAGE/CARRUSEL BODAS/1.webp": 3170,
	"./1 FRONT PAGE/CARRUSEL BODAS/2.jpg": 8707,
	"./1 FRONT PAGE/CARRUSEL BODAS/2.webp": 8067,
	"./1 FRONT PAGE/CARRUSEL BODAS/3.jpg": 3942,
	"./1 FRONT PAGE/CARRUSEL BODAS/3.webp": 5024,
	"./1 FRONT PAGE/CARRUSEL BODAS/4.jpg": 285,
	"./1 FRONT PAGE/CARRUSEL BODAS/4.webp": 6041,
	"./1 FRONT PAGE/CARRUSEL BODAS/5.jpg": 8544,
	"./1 FRONT PAGE/CARRUSEL BODAS/5.webp": 5006,
	"./1 FRONT PAGE/CARRUSEL BODAS/6.jpg": 8863,
	"./1 FRONT PAGE/CARRUSEL BODAS/6.webp": 4607,
	"./1 FRONT PAGE/CARRUSEL BODAS/7.jpeg": 2863,
	"./1 FRONT PAGE/CARRUSEL BODAS/7.webp": 6364,
	"./1 FRONT PAGE/CARRUSEL BODAS/8.webp": 5701,
	"./1 FRONT PAGE/CARRUSEL FRONT PAGE/1.jpg": 1021,
	"./1 FRONT PAGE/CARRUSEL FRONT PAGE/1.webp": 3131,
	"./1 FRONT PAGE/CARRUSEL FRONT PAGE/10.jpg": 4401,
	"./1 FRONT PAGE/CARRUSEL FRONT PAGE/10.webp": 557,
	"./1 FRONT PAGE/CARRUSEL FRONT PAGE/3.jpg": 3247,
	"./1 FRONT PAGE/CARRUSEL FRONT PAGE/3.webp": 6709,
	"./1 FRONT PAGE/CARRUSEL FRONT PAGE/4.jpg": 6868,
	"./1 FRONT PAGE/CARRUSEL FRONT PAGE/4.webp": 6500,
	"./1 FRONT PAGE/CARRUSEL FRONT PAGE/5.jpg": 465,
	"./1 FRONT PAGE/CARRUSEL FRONT PAGE/5.webp": 1207,
	"./1 FRONT PAGE/CARRUSEL FRONT PAGE/6.jpg": 4678,
	"./1 FRONT PAGE/CARRUSEL FRONT PAGE/6.webp": 5734,
	"./1 FRONT PAGE/CARRUSEL FRONT PAGE/7.jpg": 3091,
	"./1 FRONT PAGE/CARRUSEL FRONT PAGE/7.webp": 4609,
	"./1 FRONT PAGE/CARRUSEL FRONT PAGE/8.jpg": 3352,
	"./1 FRONT PAGE/CARRUSEL FRONT PAGE/8.webp": 2320,
	"./1 FRONT PAGE/CARRUSEL FRONT PAGE/9.jpg": 7317,
	"./1 FRONT PAGE/CARRUSEL FRONT PAGE/9.webp": 2755,
	"./1 FRONT PAGE/RUTA DEL VINO.jpg": 1731,
	"./1 FRONT PAGE/RUTA DEL VINO.webp": 4033,
	"./1.webp": 9665,
	"./2.webp": 404,
	"./3.webp": 3415,
	"./4.webp": 698,
	"./5.webp": 2197,
	"./6.webp": 1096,
	"./7.webp": 7547,
	"./Bodas/1.jpeg": 1284,
	"./Bodas/1.webp": 9663,
	"./Bodas/2.webp": 7214,
	"./Bodas/3.jpg": 4681,
	"./Bodas/3.webp": 6937,
	"./Bodas/4.jpg": 9194,
	"./Bodas/4.webp": 9392,
	"./Bodas/5.jpg": 3655,
	"./Bodas/5.webp": 1603,
	"./Bodas/6.jpg": 9432,
	"./Bodas/6.webp": 882,
	"./Bodas/7.jpeg": 6874,
	"./Bodas/7.webp": 7293,
	"./Bodas/8.jpg": 4406,
	"./Bodas/8.webp": 1236,
	"./Bodas/9.jpg": 7571,
	"./Bodas/9.webp": 3095,
	"./Bodas/compartida/2.jpg": 6031,
	"./Bodas/compartida/2.webp": 5365,
	"./Bodas/compartida/3.jpg": 6002,
	"./Bodas/compartida/3.webp": 3498,
	"./Bodas/compartida/4.jpg": 7697,
	"./Bodas/compartida/4.webp": 2983,
	"./Bodas/extra/1.jpg": 5912,
	"./Bodas/extra/1.webp": 2166,
	"./Bodas/extra/10.jpg": 5474,
	"./Bodas/extra/10.webp": 4122,
	"./Bodas/extra/2.jpg": 5895,
	"./Bodas/extra/2.webp": 6487,
	"./Bodas/extra/3.jpg": 4506,
	"./Bodas/extra/3.webp": 5476,
	"./Bodas/extra/4.jpg": 1225,
	"./Bodas/extra/4.webp": 9461,
	"./Bodas/extra/5.jpg": 4348,
	"./Bodas/extra/5.webp": 1642,
	"./Bodas/extra/6.jpg": 9003,
	"./Bodas/extra/6.webp": 4011,
	"./Bodas/extra/7.jpg": 958,
	"./Bodas/extra/7.webp": 9288,
	"./Bodas/extra/8.jpg": 9613,
	"./Bodas/extra/8.webp": 4729,
	"./Bodas/extra/9.jpg": 4720,
	"./Bodas/extra/9.webp": 8702,
	"./CarruselBoutique/1.jpeg": 7420,
	"./CarruselBoutique/1.webp": 9305,
	"./CarruselBoutique/2.jpg": 596,
	"./CarruselBoutique/2.webp": 6268,
	"./CarruselBoutique/3.jpeg": 742,
	"./CarruselBoutique/3.webp": 6511,
	"./CarruselBoutique/4.jpeg": 6495,
	"./CarruselBoutique/4.webp": 3282,
	"./CarruselBoutique/5.jpg": 3327,
	"./CarruselBoutique/5.webp": 8845,
	"./CarruselBoutique/6.jpg": 336,
	"./CarruselBoutique/6.webp": 528,
	"./CarruselBoutique/7.jpg": 5901,
	"./CarruselBoutique/7.webp": 931,
	"./CarruselBoutique/8.jpg": 8158,
	"./CarruselBoutique/8.webp": 1926,
	"./CarruselBoutique/9.jpg": 3115,
	"./CarruselBoutique/9.webp": 6769,
	"./EXTRA/ALBERCA/2.jpg": 6246,
	"./EXTRA/ALBERCA/2.webp": 7048,
	"./EXTRA/IMG_3023-min-2-scaled.jpg": 2502,
	"./EXTRA/IMG_3023-min-2-scaled.webp": 8764,
	"./IMAGENES/La Capilla Horizontal 3.jpg": 7546,
	"./IMAGENES/La Capilla Horizontal 3.webp": 2886,
	"./JuniorSuiteDeluxe/1.png": 6468,
	"./JuniorSuiteDeluxe/1.webp": 5054,
	"./JuniorSuiteDeluxe/2.png": 1583,
	"./JuniorSuiteDeluxe/2.webp": 2207,
	"./JuniorSuiteDeluxe/3.jpg": 8482,
	"./JuniorSuiteDeluxe/3.webp": 668,
	"./JuniorSuiteDeluxe/4.jpg": 3089,
	"./JuniorSuiteDeluxe/4.webp": 9885,
	"./JuniorSuiteDeluxe/5.jpg": 8756,
	"./JuniorSuiteDeluxe/5.webp": 3218,
	"./La-Capialla-Hotel-Vector-scaled.png": 1027,
	"./La-Capialla-Hotel-Vector-scaled.webp": 9447,
	"./La-capilla-Hotel.png": 9723,
	"./La-capilla-Hotel.webp": 1013,
	"./MasterSuiteDeluxe/1.png": 2655,
	"./MasterSuiteDeluxe/1.webp": 6283,
	"./MasterSuiteDeluxe/2.png": 5796,
	"./MasterSuiteDeluxe/2.webp": 9434,
	"./MasterSuiteDeluxe/3.jpg": 573,
	"./MasterSuiteDeluxe/3.webp": 933,
	"./MasterSuiteDeluxe/4.jpg": 9110,
	"./MasterSuiteDeluxe/4.webp": 9140,
	"./MasterSuiteDeluxe/5.jpg": 2275,
	"./MasterSuiteDeluxe/5.webp": 2151,
	"./StandarDeluxe/1.jpg": 3136,
	"./StandarDeluxe/1.webp": 7494,
	"./StandarDeluxe/2.jpg": 8095,
	"./StandarDeluxe/2.webp": 8519,
	"./StandarDeluxe/3.jpg": 8098,
	"./StandarDeluxe/3.webp": 5508,
	"./StandarDeluxe/4.jpg": 4657,
	"./StandarDeluxe/4.webp": 7301,
	"./StandarDeluxe/5.jpg": 3751,
	"./StandarDeluxe/5.webp": 5802,
	"./StandarDeluxe/6.jpg": 7939,
	"./StandarDeluxe/6.webp": 2651,
	"./V9 CAPILLA CUARTOS.mp4": 5405,
	"./habitaciones/aire.svg": 2024,
	"./habitaciones/metros.svg": 6791,
	"./habitaciones/noun_Bed_1135101.png": 340,
	"./habitaciones/noun_Bed_1135101.webp": 1782,
	"./habitaciones/noun_City_4117559.png": 5784,
	"./habitaciones/noun_City_4117559.webp": 4568,
	"./habitaciones/noun_Shower_2884186.png": 1590,
	"./habitaciones/noun_Shower_2884186.webp": 5142,
	"./habitaciones/noun_TV_1485615.png": 9149,
	"./habitaciones/noun_TV_1485615.webp": 3679,
	"./habitaciones/noun_room_2578943.png": 4868,
	"./habitaciones/noun_room_2578943.webp": 188,
	"./habitaciones/noun_wifi_4115433.png": 9293,
	"./habitaciones/noun_wifi_4115433.webp": 5163,
	"./iconossvg/Recurso-17.svg": 2816,
	"./iconossvg/Recurso-18.svg": 8647,
	"./iconossvg/Recurso-19-1.svg": 6972,
	"./iconossvg/Recurso-23.svg": 217,
	"./iconossvg/Recurso-24.svg": 6534,
	"./iconossvg/Recurso-25.svg": 6071,
	"./iconossvg/Recurso-27.svg": 9493,
	"./iconossvg/Recurso-3.svg": 375,
	"./iconossvg/Recurso-8.svg": 8108,
	"./juniorsuit/1.webp": 2114,
	"./juniorsuit/2.webp": 9763,
	"./juniorsuit/3.webp": 4000,
	"./juniorsuit/4.webp": 4153,
	"./juniorsuit/5.webp": 8126,
	"./juniorsuit/POTADAJUNIORSUITE.webp": 3329,
	"./mastersuit/1.webp": 5601,
	"./mastersuit/2.webp": 4964,
	"./mastersuit/3.jpg": 1749,
	"./mastersuit/3.webp": 8663,
	"./mastersuit/4.jpg": 8334,
	"./mastersuit/4.webp": 9178,
	"./mastersuit/5.jpg": 4171,
	"./mastersuit/5.webp": 1045,
	"./mastersuit/6.jpg": 2652,
	"./mastersuit/6.webp": 8616,
	"./mastersuit/7.jpg": 7001,
	"./mastersuit/7.webp": 8523,
	"./mastersuit/8.jpg": 4082,
	"./mastersuit/8.webp": 6702,
	"./mastersuit/PORTADAMASTERSUITE.jpg": 9571,
	"./mastersuit/PORTADAMASTERSUITE.webp": 2687,
	"./portadashome/1.jpg": 4097,
	"./portadashome/1.webp": 3407,
	"./portadashome/PORTADAHOTELBOUTIQUE.jpg": 2603,
	"./portadashome/PORTADAHOTELBOUTIQUE.webp": 8735,
	"./standar/1.webp": 8701,
	"./standar/2.webp": 4448,
	"./standar/3.webp": 6659,
	"./standar/4.webp": 2270,
	"./standar/5.webp": 1993,
	"./standar/6.webp": 7628,
	"./standar/PORTADASTANDARD.webp": 830,
	"./whats.jpg": 7285,
	"./whats.webp": 4374
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4363;